import { render, staticRenderFns } from "./usertable.vue?vue&type=template&id=b274a8b8"
import script from "./usertable.vue?vue&type=script&lang=js"
export * from "./usertable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports